import { useState, useEffect } from 'react'
import MainPageWrapper from '../../global/components/MainPageWrapper'
import TabChooser from './TabChooser'
import InstallationAuditsTable from '../components/tables/InstallationAuditsTable'
import LocationDropDown from '../../global/components/location-drop-down/LocationDropDown'
import { AuditContextProvider } from '../../global/context/audit-context/AuditContext'
import DvirAuditsTable from '../components/tables/DvirAuditsTable'
import CoachingAuditsTable from '../components/tables/CoachingAuditsTable'
import AITrainingTable from '../components/tables/AITrainingTable'
import VanDownAuditsTable from '../components/tables/VanDownAuditsTable'
import { AUDIT_KEYS } from '../../global/constants/audit'
import MessageIcon from '@mui/icons-material/Message'
import MessageModal from '../components/technician-messaging/MessageModal'
import styles from './styles.module.css'
export interface ILocationFilters {
  locationFilter: string
  setLocationFilter: Function
}

interface IAuditsMainProps {
  tabType: AUDIT_KEYS
}

function AuditsMain({ tabType }: IAuditsMainProps) {
  const [refetchIndex, setRefetchIndex] = useState(0)
  const [locationFilter, setLocationFilter] = useState('')
  const [messageModalOpen, setMessageModalOpen] = useState(false)

  let table = null

  const showLocationDropdown = [
    AUDIT_KEYS.coaching,
    AUDIT_KEYS.vanDown,
  ].includes(tabType)
  const showMessageButton = tabType === AUDIT_KEYS.dvir

  useEffect(() => {
    setLocationFilter('')
  }, [tabType])

  switch (tabType) {
    case AUDIT_KEYS.installation:
      table = (
        <InstallationAuditsTable
          setRefetchIndex={setRefetchIndex}
          refetchIndex={refetchIndex}
          locationFilters={{ locationFilter, setLocationFilter }}
        />
      )
      break
    case AUDIT_KEYS.dvir:
      table = (
        <DvirAuditsTable
          setRefetchIndex={setRefetchIndex}
          refetchIndex={refetchIndex}
          locationFilters={{ locationFilter, setLocationFilter }}
        />
      )
      break
    case AUDIT_KEYS.coaching:
      table = (
        <CoachingAuditsTable
          setRefetchIndex={setRefetchIndex}
          refetchIndex={refetchIndex}
          locationFilters={{ locationFilter, setLocationFilter }}
        />
      )
      break
    case AUDIT_KEYS.aiTraining:
      table = <AITrainingTable />
      break
    case AUDIT_KEYS.vanDown:
      table = (
        <VanDownAuditsTable
          setRefetchIndex={setRefetchIndex}
          refetchIndex={refetchIndex}
          locationFilters={{ locationFilter, setLocationFilter }}
        />
      )
      break
  }

  return (
    <AuditContextProvider>
      <MainPageWrapper
        title='Audits'
        titleFields={
          <>
            {showLocationDropdown && (
              <div style={{ marginRight: 'auto', marginLeft: '1rem' }}>
                <LocationDropDown
                  onLocationChange={(val: string) => {
                    setLocationFilter(val)
                  }}
                />
              </div>
            )}
            {showMessageButton && (
              <div style={{ marginLeft: 'auto' }}>
                <button
                  className={styles.buttonPrimary}
                  onClick={() => setMessageModalOpen(true)}
                >
                  <MessageIcon style={{ marginRight: '8px' }} /> Technician
                  Messages
                </button>
              </div>
            )}
          </>
        }
      >
        <TabChooser />
        {table}
        <MessageModal
          open={messageModalOpen}
          onClose={() => setMessageModalOpen(false)}
        />
      </MainPageWrapper>
    </AuditContextProvider>
  )
}

export default AuditsMain
